import { render, staticRenderFns } from "./BitrixResendButton.vue?vue&type=template&id=51316c16&scoped=true"
import script from "./BitrixResendButton.vue?vue&type=script&lang=js"
export * from "./BitrixResendButton.vue?vue&type=script&lang=js"
import style0 from "./BitrixResendButton.vue?vue&type=style&index=0&id=51316c16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51316c16",
  null
  
)

export default component.exports